module.exports = __webpack_public_path__ + "img/Shabeb-logo.60833e9f.svg";